// extracted by mini-css-extract-plugin
export default {"overlay":"NotificationCentre_overlay__RazeN","modalContainer":"NotificationCentre_modalContainer__OHsA8","label":"NotificationCentre_label__VrRa9"};